import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteOrder } from '../actions/orderActions';
import { ReactComponent as SuccessfulDeletion } from '../assets/rubbish.svg';
import { ORDER_TYPES } from '../helpers/constants';
import {
  getLatestOrderOfOrderType,
  getProductFromOrderType,
} from '../helpers/product.helpers';
import { orderDetailsSelector } from '../selectors/bundleSelectors';
import { ENTITY_TYPE } from './utils';

const DeleteOrder = (props) => {
  const {
    intl,
    deleteOrder,
    token,
    currentOrderSelected,
    orderDeleteError,
    isOrderDeleting,
    isOrderDeleteSuccess,
    closeModal,
    orderType,
  } = props;

  // Manage only the necessary local state (i.e. the reason for deletion)
  const [reason, setReason] = useState('');

  const orders = useSelector(orderDetailsSelector);

  const order = getProductFromOrderType(orderType);

  const changeReason = useCallback((e) => {
    setReason(e.target.value);
  }, []);

  const handleDeleteClick = useCallback(() => {
    const order = getLatestOrderOfOrderType(orders, orderType);
    const payload = {
      entityId: order.id,
      entityType: ENTITY_TYPE.ORDER.toUpperCase(),
      note: reason,
    };
    deleteOrder(payload, token, currentOrderSelected.region);
  }, [reason, deleteOrder, token, currentOrderSelected]);

  const buttonContent = isOrderDeleting ? (
    <div className="deleting-order-div">
      <div className="spinner" />
      <span className="deleting">
        <FormattedMessage id="deleting-button-text" />
      </span>
    </div>
  ) : (
    <FormattedMessage id="delete-button-text" />
  );

  if (isOrderDeleteSuccess) {
    return (
      <div className="delete-order-success">
        <SuccessfulDeletion />
        <span className="delete-orders-header">{order}</span>
        <FormattedMessage id="delete-order-successful" />
      </div>
    );
  }

  return (
    <div className="delete-order-content">
      <span className="delete-orders-header">
        <FormattedMessage
          id="delete-domain-order"
          values={{ orderType: order }}
        />
      </span>
      {orderDeleteError && !isOrderDeleting && (
        <div className="delete-order-error">{orderDeleteError}</div>
      )}
      <div className="delete-orders-message">
        <FormattedMessage
          id={
            orderType === ORDER_TYPES.MAIL
              ? 'delete-order-modal-message'
              : 'delete-order-modal-message-site'
          }
        />
      </div>
      <fieldset className="t-form-field">
        <FormattedMessage tagName="label" id="delete-order-reason-label" />
        <input
          placeholder={intl.formatMessage({ id: 'delete-order-reason' })}
          onChange={changeReason}
          value={reason}
        />
      </fieldset>
      <div className="delete-buttons">
        <button
          className="button button-delete delete-order-button"
          onClick={handleDeleteClick}
          disabled={isOrderDeleting}
        >
          {buttonContent}
        </button>
        <button
          className="button button-cancel delete-order-button"
          onClick={() => closeModal(null, null)}
          disabled={isOrderDeleting}
        >
          <FormattedMessage id="cancel" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
  orderDeleteError: state.orders.orderDeleteError,
  isOrderDeleting: state.orders.isOrderDeleting,
  isOrderDeleteSuccess: state.orders.isOrderDeleteSuccess,
  currentOrderSelected: state.orders.currentOrderSelected,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ deleteOrder }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DeleteOrder));
